module.exports = __webpack_public_path__ + "img/logo.313f4f6a.png";